import { create } from 'zustand';

const initialState = {
  link: null,
  qrCode: null,
  qrCodeLink: null,
  buttonCode: null,
  buttonId: null
};

export const useMethodStore = create((set) => ({
  ...initialState,

  setLink: (link) => set({ link }),
  setQrCode: (qrCode) => set({ qrCode }),
  setQrCodeLink: (qrCodeLink) => set({ qrCodeLink }),
  setButtonCode: (buttonCode) => set({ buttonCode }),
  setButtonId: (buttonId) => set({ buttonId }),
  resetMethod: () => set(initialState)
}));

export const useLink = () => useMethodStore(state => state.link);
export const useStripeLink = () => useMethodStore(state => state.stripeLink);
export const useQrCode = () => useMethodStore(state => state.qrCode);
export const useQrCodeLink = () => useMethodStore(state => state.qrCodeLink);
export const useButtonCode = () => useMethodStore(state => state.buttonCode);
export const useButtonId = () => useMethodStore(state => state.buttonId);

export const useSetLink = () => useMethodStore(state => state.setLink);
export const useSetStripeLink = () => useMethodStore(state => state.setStripeLink);
export const useSetQrCode = () => useMethodStore(state => state.setQrCode);
export const useSetQrCodeLink = () => useMethodStore(state => state.setQrCodeLink);
export const useSetButtonCode = () => useMethodStore(state => state.setButtonCode);
export const useSetButtonId = () => useMethodStore(state => state.setButtonId);
export const useResetMethod = () => useMethodStore(state => state.resetMethod);
